<template>
  <div class='invoicePage'>
      <p class='header'>
          发票信息
          <button @click='goBack' >返回上一页</button>
      </p>
      <Form :model="formData" class='myForm'>
        <FormItem label="发票类型" prop='invoice_type' >
            <RadioGroup v-model="formData.invoice_type" @on-change='typeSelect'>
                <Radio label="个人">个人</Radio>
                <Radio label="企业普通">企业普通</Radio>
            </RadioGroup>
        </FormItem>        
        <FormItem label="金额(元)" prop='invoice_money'>
             <Input v-model="formData.invoice_money" type="text" readonly  class="readonly myInput" ></Input>
        </FormItem>        
        <FormItem label="发票抬头" prop='invoice_rise' >
             <Input v-model="formData.invoice_rise" type="text" class='myInput' maxlength=30></Input>
        </FormItem>          
        <FormItem v-show='this.formData.invoice_type=="企业普通"' label="纳税人识别号" prop='individual_num'>
             <Input v-model="formData.individual_num" type="text" class='myInput' maxlength=30></Input>
        </FormItem>
        <p class='header'>邮寄信息</p>       
        <FormItem label="电子邮箱地址" prop='mail_address'>
             <Input v-model="formData.mail_address" type="text" class='myInput' maxlength=40></Input>
        </FormItem>
        <FormItem label="联系人" prop='contacts_name'>
             <Input v-model="formData.contacts_name" type="text" class='myInput' maxlength=10></Input>
        </FormItem>        
        <FormItem label="联系电话" prop='contact_tel'>
             <Input v-model="formData.contact_tel" type="text" class='myInput' maxlength=11  @on-change='toNum'></Input>
        </FormItem>
      </Form>
      <Button type="primary" @click="submitInvoice" class='submit'>提交</Button>
      <Button type="primary" @click="goServer" class='submit' style="marginLeft:30px">联系客服</Button>
      <!-- <p class='title'>注：快递随机中通，圆通，申通，汇通，京东，如需指定快递，请联系客服</p> -->
  </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js"
export default {
    data(){
        return {
            formData:{
                invoice_money:'',
                invoice_type:'个人'
            },//发票表单
            orderid_Str:'',//需要开票的订单
            invoice_money:'',//需要开票的金额
        }
    },
    methods:{
        goBack(){
            this.$emit('gorecharge','2');
            this.$router.push('/Personal');
            this.$store.state.ShowSubContainer=false;
        },
        typeSelect(val){
            console.log();
        },
        submitInvoice(){
            if(this.formData.mail_address&&this.formData.contacts_name&&this.formData.contact_tel){
                doPost(
                    {action:'invoice_Submit',session_str:localStorage.getItem('session_str'),
                        orderid_Str:this.orderid_Str,
                        invoice_type:this.formData.invoice_type,
                        invoice_money:this.formData.invoice_money,
                        invoice_rise:this.formData.invoice_rise,
                        individual_num:this.formData.individual_num?this.formData.individual_num:'',
                        mail_address:this.formData.mail_address,
                        contacts_name:this.formData.contacts_name,
                        contact_tel:this.formData.contact_tel,
                    },
                    (res)=>{
                        if(!res.status){
                            // alert('发票提交成功')  成功的提醒
                            this.$Message.success(res.detail)
                            setTimeout(()=>{
                                this.goBack();
                            },1500)
                        }else{                            
                            this.$Message.error(res.detail)
                        }
                    }
                )
            }else{
                // 邮寄信息有任一部分没填写 均不可
                this.$Message.error('请检查信息填写是否有误')
            }
        },
        goServer(){
            window.open('https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump.html?linkType=0&env=ol&kfuin=2852181984&fid=114&key=f0649e850ed0600f46556d7fdd041844&cate=1&type=16&ftype=1&_type=wpa&qidian=true')
        },
        toNum(){
            this.$nextTick(() => {
                this.formData.contact_tel=this.formData.contact_tel.replace(/\D/g,"");
            });
        }
    },
    created(){
        this.orderid_Str=localStorage.getItem('orderid_Str');
        // this.invoice_money=JSON.parse(localStorage.getItem('orderInfo')).invoice_money;
        this.formData.invoice_money=localStorage.getItem('invoice_money');
    },

}
</script>

<style lang="stylus" scoped>
.invoicePage {
    width  100%
    // height 494px
    box-sizing border-box
    padding 30px 30px 50px
}
.invoicePage .header {
    font-size 16px
    text-align left
    margin-bottom 15px
}
.invoicePage .header button{
    float right 
    border none
    cursor pointer
    font-size 14px
    margin-top 3px
    background-color #fff
}
.invoicePage >>>.ivu-form-item-content{
    float right    
    margin-left 20px
}
.invoicePage >>>.ivu-form-item{
    margin-bottom 15px
}
.invoicePage .submit{
    width 100px
    font-size 14px
    float left
    margin-left 150px
}

.invoicePage .readonly>>>.ivu-input{
    background-color #ccc
}
.invoicePage p.title {
    color red
    font-size 14px
    margin 27px 0 0 400px
}

.invoicePage .myForm {
    width 450px
}
.invoicePage .myInput {
    width 300px
}

@media screen and (max-width: 768px) {
    .invoicePage .submit{
        margin-left 0
    }
    .invoicePage >>>.ivu-form {
        width 100%
    }
    .invoicePage >>>.ivu-form-item .ivu-input-wrapper{
        width 260px
    }
    .invoicePage .myForm {
        width 100%
    }
    .invoicePage .myInput {
        width 260px
    }
    
}

</style>


// WEBPACK FOOTER //
// src/pages/Personal/components/Invoice.vue